import { useEffect, useState, useCallback } from "react";
import { useQueries } from "@tanstack/react-query";
import { toast } from "sonner";

// fetch
import { getMeiliTaskStatus } from "data/fetch";

// types
import { MeiliTaskStatus } from "types/extended-profile.types";

export function useMeiliTaskToast() {

	const [tasks, setTasks] = useState<MeiliTaskStatus[]>([]);

	const addTask = useCallback((task: MeiliTaskStatus) => {
		if (!task?.taskUid) {
			setTasks(prev => prev.filter(t => t.taskUid));
			toast.success(
				<div>
					{task?.label} changes are processing and will be reflected in search within the <strong>next business day</strong>
				</div>,
				{ duration: Infinity }
			);
			return
		}
		setTasks((prev) => [...prev, task]);
	}, []);

	const queries = useQueries({
		queries: tasks.map((task) => ({
			queryKey: ["meiliTaskStatus", task?.taskUid],
			queryFn: () => getMeiliTaskStatus(task?.taskUid, task?.label),
			enabled: !!task?.taskUid,
		})),
	});

	const queryData = queries.map(task => task.data)

	useEffect(() => {
		if (queryData?.length > 0) {
			queryData.forEach((task) => {
				if (!task) return; // skip until data is loaded
				if (task?.status === 'succeeded') {
					setTasks((prev) => prev.filter(t => t.taskUid !== task.taskUid));
					toast.success(`${task?.label} updated successfully`, { description: "Your profile updates are now reflected in search results", duration: Infinity });
				} else {
					setTasks((prev) => prev.filter(t => t.taskUid !== task.taskUid));
					toast.success(
						<div>
							{task?.label} changes are processing and will be reflected in search within the <strong>next business day</strong>
						</div>,
						{ duration: Infinity }
					);
				}
			});
		}
	}, [queryData]);

	return addTask
}